module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAMAAADzapwJAAAAAXNSR0IB2cksfwAAAHJQTFRFAAAAiJionqy5r7rE////ytHY2+DkyNDX6ezv5+vu4ebp8/X2+/v8/f3+rrnEx8/Ws77H4OTo/f7+g5Wlo7K/iJmp4evyiJmoeIub0Nzl0Nzke46Xmqq43Obumaq4e46heoubg5SllaS0lqe1gpSkd42dcmtDtwAAACZ0Uk5TAMfH/////////////////////8P/r/+ve///G+v/7BsupMXHpS8Ya/ZgAAAAZ0lEQVR4nK3QVwqAMBRE0VFj7z2W2N3/FkXIh8aIiJ7PS3gMAaCoAgU7jQi0X7NuEJOzDtmwicO5z0c8X5qDkERcfHydvBl4s+Rm99c/STOJFHkhUYJW11pTNC0TK+t6YBin+WRaVmwMWRA1J6G9KwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/icons8-rules@2x.png
// module id = bvff
// module chunks = 1